module.exports = __webpack_public_path__ + "static/media/vector-4965.d8e82481.svg";